import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./tipiTiraggioStore"
import Actions from "./tipiTiraggioActions"

export let withTipiTiraggio = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getAll());